import React, { useState, useEffect } from "react";
import * as SC from "./styled";
import { Title, HR } from "./item/styled";
import Item from "./item";

const Link = ({ data }) =>
  data.target ? (
    <SC.ExternalLink {...data} href={data.url}>
      {data.name}
    </SC.ExternalLink>
  ) : (
    <SC.DirectLink {...data} to={data.url}>
      {data.name}
    </SC.DirectLink>
  );

const toggleBodyContent = disable => {
  const mainBodyContent = document.querySelector("main");
  const footerContent = document.querySelector("footer");

  if (disable) {
    mainBodyContent?.setAttribute("inert", "true");
    footerContent?.setAttribute("inert", "true");
    document.body.style.overflow = "hidden";
  } else {
    document.body.style.overflow = "";
    mainBodyContent?.removeAttribute("inert");
    footerContent?.removeAttribute("inert");
  }
};

const Menu = ({ data }) => {
  const [itemIndex, setItemIndex] = useState();

  const handleAccordion = index => {
    const updated = itemIndex === index ? false : index;
    setItemIndex(updated);
  };

  useEffect(() => {
    toggleBodyContent(true);
    return () => {
      toggleBodyContent();
    };
  }, []);

  return (
    <SC.Container>
      <SC.MenuItems>
        {data.items ? (
          data.items.map((item, i) =>
            item.url ? (
              <SC.TitleContainer key={i}>
                <Link data={item} />
              </SC.TitleContainer>
            ) : (
              <div key={i}>
                <SC.TitleContainer
                  active={itemIndex === i}
                  onClick={() => handleAccordion(i)}
                >
                  <Title>{item.name}</Title>
                  <SC.ArrowIcon />
                </SC.TitleContainer>

                <SC.ItemWrapper active={itemIndex === i}>
                  <Item data={item} hideTitle />
                  <HR style={{ marginTop: "14px" }} />
                </SC.ItemWrapper>
              </div>
            )
          )
        ) : (
          <Item data={data} />
        )}
      </SC.MenuItems>
    </SC.Container>
  );
};

export default Menu;
